<template>
  <div class="ep-transfer-panel">
    <div class="ep-transfer-panel__header">
      <div class="ep-transfer-panel_hlt" @click="select_all">
        <input type="checkbox" :checked="isSelectAll" name="" id="">
      </div>
      <div class="ep-transfer-pannel_hcon">
        <slot name="header"></slot>
      </div>
      <div class="ep-transfer-panel_hrt">{{select.length}}/{{dataList.length}}</div>
    </div>
    <div class="ep-transfer-panel__body">
      <div class="ep-transfer-panel_search" v-if="filters">
        <slot name="search"></slot>
      </div>
      <div v-if="dataList!=''" :class="['ep-transfer-panel-bcon',{'is-filters':filters}]">
        <div class="ep-transfer-panel-blist" v-for="(m, i) in dataList" ::key="i" @click="select_current(m)">
          <div class="ep-transfer-panel_blt">
            <input type="checkbox" :checked="selectState[m.key]" name="" id="">
          </div>
          <div :class="['ep-transfer-pannel_bcon',{'ep-transfer-pannel_select':selectState[m.key]}]">
            {{m.label}}
          </div>
          <!-- <div class="ep-transfer-panel_brt">{{i+1}}</div> -->
        </div>
      </div>
      <div v-else class="ep-transfer-panel-blist ep-tranfer-data_null">暂无数据</div>
    </div>
    <div class="ep-transfer-panel__footer"></div>
  </div>
</template>

<script>
  import unit from '../../../lib/unit'

  export default {
    name: 'ep-transfer-panel',
    props: {
      options: {
        type: Array,
        default() {
          return []
        }
      },
      filters: {
        type: Boolean,
        default: false
      },
      custom: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isSelectAll: false,
        select: [],
        selectState: {},
        dataList: []
      }
    },
    watch: {
      select() {
        this.dispatch('ep-transfer', 'select', this.select, this.custom)
        if (this.select.length == this.dataList.length && !this.isSelectAll && this.select.length > 0) {
          this.isSelectAll = true
        }
        if ((this.select.length < this.dataList.length && this.isSelectAll) || this.select.length == 0) {
          this.isSelectAll = false
        }
      },
      dataList() {
        if (this.custom == 'result') {
          this.dispatch('ep-transfer', 'change', this.select, this.custom)
        }
      }
    },
    created() {
      this.init_dataList()
      this.bind_event()
    },
    mixins: [unit],
    methods: {
      // 初始化参数
      init_dataList() {
        this.dataList = JSON.parse(JSON.stringify(this.options))
      },
      // 监听父级通知
      bind_event() {
        this.$on('controll', (val, name) => {
          console.log(JSON.stringify(val), name)
          if (this.custom != name) {
            this.select_add(val)
          } else {
            this.select_remove(val)
          }
        })
      },
      // 添加选中数据
      select_add(val) {
        this.dataList = this.dataList.concat(JSON.parse(JSON.stringify(val))).sort((a, b) => {
          return a.key - b.key
        })
      },
      // 移除选中数据
      select_remove(val) {
        let newList = this.to_object(this.dataList)
        val.forEach(ele => {
          delete newList[ele.key]
        })
        this.dataList = this.to_array(newList)
        this.select = []
        this.selectState = {}
      },
      // 选中或取消全部
      select_all() {
        this.isSelectAll = !this.isSelectAll
        if (this.isSelectAll) {
          let sAll = JSON.parse(JSON.stringify(this.dataList))
          this.select = sAll
          this.selectState = this.to_object(sAll)
        } else {
          this.select = []
          this.selectState = {}
        }
      },
      // 选中当前对象
      select_current(val) {
        if (!this.selectState[val.key]) {
          this.select.push(val)
          this.selectState = this.to_object(this.select)
        } else {
          let newState = JSON.parse(JSON.stringify(this.selectState))
          delete newState[val.key]
          this.selectState = newState
          this.select = this.to_array(this.selectState)
        }
      },
      // 转换为数组
      to_array(data) {
        if (!data instanceof Object) return
        let newArr = []
        for (let m in data) {
          newArr.push({
            key: m,
            label: data[m]
          })
        }
        return newArr
      },
      // 转换为对象
      to_object(data) {
        if (!data instanceof Array || !data[0] instanceof Object) return
        let newMap = {}
        data.map((m) => {
          newMap[m.key] = m.label
        })
        return newMap
      }
    }
  }
</script>

<style scoped>
  .ep-transfer-panel {
    width: 200px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    display: inline-block;
    max-height: 100%;
    box-sizing: border-box;
    vertical-align: middle;
  }

  .ep-transfer-panel__header {
    line-height: 36px;
    height: 36px;
    width: 100%;
    background: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
    position: relative;
    box-sizing: border-box;
  }

  .ep-transfer-pannel_hcon,
  .ep-transfer-pannel_bcon {
    height: 100%;
    width: 100%;
    padding: 0 30px;
    font-size: 12px;
    box-sizing: border-box;
  }

  .ep-transfer-panel_hlt,
  .ep-transfer-panel_hrt {
    position: absolute;
    height: 100%;
    width: 30px;
    line-height: 36px;
    top: 0;
    text-align: center;
  }

  .ep-transfer-panel_blt,
  .ep-transfer-panel_brt {
    position: absolute;
    height: 100%;
    width: 30px;
    line-height: 30px;
    top: 0;
    text-align: center;
  }

  .ep-transfer-panel_hlt {
    left: 0;
  }

  .ep-transfer-panel_hrt,
  .ep-transfer-panel_brt {
    right: 0;
    font-size: 12px;
    color: #909399;
  }

  .ep-transfer-panel_hlt input {
    height: 14px;
    width: 14px;
    display: inline-block;
    vertical-align: middle;
  }


  .ep-transfer-panel__body {
    height: 264px;
    width: 100%;
    position: relative;
  }

  .ep-transfer-panel_search {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    padding: 5px 10px;
  }

  .ep-transfer-panel-bcon {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: auto;
    overflow-x: hidden;
  }

  .ep-transfer-panel-bcon::-webkit-scrollbar {
    width: 8px;
    height: 100%;
  }

  .ep-transfer-panel-bcon::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 4px;
  }

  .ep-transfer-panel:hover .ep-transfer-panel-bcon::-webkit-scrollbar-thumb {
    background: hsla(220, 4%, 58%, .3);
  }

  .is-filters {
    height: calc(100% - 40px);
  }

  .ep-transfer-panel-blist {
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    position: relative;
    line-height: 30px;
    cursor: pointer;
  }

  .ep-transfer-panel-blist:hover {
    color: #409EFF;
  }

  .ep-transfer-pannel_select {
    color: #409EFF;
  }

  .ep-tranfer-data_null {
    font-size: 12px;
    text-align: center;
    line-height: 40px;
    color: #909399;
  }
</style>


// WEBPACK FOOTER //
// transfer-panel.vue?1938391e